var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHu = function SvgHu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M640.006 479.994H0V0h640.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#388d00",
    d: "M640.006 479.994H0V319.996h640.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d43516",
    d: "M640.006 160.127H0V.13h640.006z"
  }))));
};
export default SvgHu;